import { z } from "zod";
import type { CloudIdentity } from "./common.js";

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1)
});

export const registerSchema = z.object({
  tenantName: z.string().trim().min(1).max(120),
  email: z.string().trim().email(),
  password: z
    .string()
    .min(8)
    .max(200)
    .refine((value) => value.trim().length > 0),
  confirmPassword: z
    .string()
    .min(8)
    .max(200)
    .refine((value) => value.trim().length > 0)
});

export const refreshSchema = z.object({
  refreshToken: z.string().min(1)
});

export const logoutSchema = z.object({
  refreshToken: z.string().optional()
});

export type LoginInput = z.infer<typeof loginSchema>;
export type RegisterInput = z.infer<typeof registerSchema>;
export type RefreshInput = z.infer<typeof refreshSchema>;
export type LogoutInput = z.infer<typeof logoutSchema>;

export interface CloudSession extends CloudIdentity {
  accessToken: string;
  refreshToken: string;
}
